import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {AlertService, OperatorService, UserService} from "../services";
import {Subject} from "rxjs";

import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {SupplierService} from "../services/supplier.service";
import {SupplierOrderService} from "../services/supplierOrder.service";

@Component({
    templateUrl: './supplierOrder.component.html',
    styleUrls: ['./supplierOrder.component.scss']
})
export class SupplierOrderComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private supplierService: SupplierService,
        private supplierOrderService: SupplierOrderService,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish);
        componentTitleService.clearTitle();
        componentTitleService.addPart('Supplier orders');
    }

    ngOnInit() {
        this.supplierOrderService.getAll().subscribe((res: any[])=>{
            this.rows = res;
            this.loadingIndicator = false;
        }, error => {
            this.alertService.error(error);
        })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
